module.exports = __webpack_public_path__ + "img/16m004-07.d522c483.jpg";